import React from 'react';
import './index.less';
import Ticon from '../Icon';

export default class ButtonGroup extends React.Component {
  state = {}

  constructor(props) {
    super(props);
  }

  onClick = item => {
    console.log(item);
    this.props.onChange && this.props.onChange(item)
  }

  render() {
    const { items, value, type } = this.props;
    return (
      <div className='buttonGroup'>
        {
          items.map(item => (
            <div onClick={this.onClick.bind(this, item)} key={item.id} className={`buttonGroup-item ${value.id == item.id ? 'buttonGroup-item-checked' : ''}`}>
              {item.name}
              {
                type == 'icon' ?
                <Ticon type='xuanzhongdanwei' className='xuanzhongdanwei-icon' />
                :
                null
              }
            </div>
          ))
        }
      </div>
    )
  }

}
